// extracted by mini-css-extract-plugin
export default {"contactSocialBlock":"contactComponent_contactSocialBlock__cS-Tz","contactsSocial":"contactComponent_contactsSocial__vTrwW"};